var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","role":"presentation","focusable":"false","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }